import React from 'react';
import { Upload, Loader2 } from 'lucide-react';
import { Label } from '../ui/label';

/**
 * Square / banner image uploader with current preview + clear button.
 * Used by both Agency and Agent dashboards.
 *
 * Props:
 *   label, current (url|null), uploading, onFile, onClear, testid,
 *   aspect (Tailwind class, default 'aspect-square'),
 *   rounded (Tailwind class, default 'rounded-xl'),
 *   helper (optional sub-label)
 */
export default function ImageUploader({
  label, current, uploading, onFile, onClear, testid,
  aspect = 'aspect-square', rounded = 'rounded-xl', helper,
}) {
  return (
    <div data-testid={testid}>
      <Label className="text-xs uppercase tracking-widest text-gray-500 block mb-1.5">{label}</Label>
      <label className={`relative ${aspect} block ${rounded} overflow-hidden border-2 border-dashed border-gray-300 hover:border-habita cursor-pointer transition-colors group`}>
        {current ? (
          <>
            <img src={current} alt="" className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 flex items-center justify-center transition-opacity">
              <span className="text-white text-xs font-semibold">Reemplazar</span>
            </div>
          </>
        ) : (
          <div className="w-full h-full flex flex-col items-center justify-center text-gray-400 text-xs gap-1">
            <Upload className="w-5 h-5" />
            <span>Click o arrastra una imagen</span>
          </div>
        )}
        {uploading && (
          <div className="absolute inset-0 bg-white/80 flex items-center justify-center">
            <Loader2 className="w-6 h-6 animate-spin text-habita" />
          </div>
        )}
        <input type="file" accept="image/*" className="hidden" onChange={onFile} data-testid={`${testid}-input`} />
      </label>
      <div className="flex items-center justify-between mt-1.5">
        {helper && <p className="text-[11px] text-gray-500">{helper}</p>}
        {current && (
          <button onClick={onClear} className="text-xs text-rose-600 hover:underline ml-auto" data-testid={`${testid}-clear`}>
            Quitar
          </button>
        )}
      </div>
    </div>
  );
}
